// Returns timestamp at beginning of current day
export default () => new Date().setHours(0, 0, 0, 0)
